module.exports = __webpack_public_path__ + "static/media/09-slider-enlarged.c7fd659b.png";